module.exports = __webpack_public_path__ + "img/enfj.a58e1ca7.png";